"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.termsOfUseStateFactory = exports.userStateFactory = exports.customerLoadingFactory = exports.TERMS_OF_USE_STATUSES = exports.UNITS_SYSTEM_TYPES = void 0;
var safety_dto_1 = require("../dtos/safety.dto");
var UNITS_SYSTEM_TYPES;
(function (UNITS_SYSTEM_TYPES) {
    UNITS_SYSTEM_TYPES["METRIC"] = "metric";
    UNITS_SYSTEM_TYPES["IMPERIAL"] = "imperial";
})(UNITS_SYSTEM_TYPES = exports.UNITS_SYSTEM_TYPES || (exports.UNITS_SYSTEM_TYPES = {}));
var TERMS_OF_USE_STATUSES;
(function (TERMS_OF_USE_STATUSES) {
    TERMS_OF_USE_STATUSES["ACCEPTED"] = "Accepted";
    TERMS_OF_USE_STATUSES["REJECTED"] = "Rejected";
})(TERMS_OF_USE_STATUSES = exports.TERMS_OF_USE_STATUSES || (exports.TERMS_OF_USE_STATUSES = {}));
/** FACTORIES */
var customerLoadingFactory = function (config) { return (__assign({ canResolveFaults: false, fleetWideView: false, collisionMitBraking: false, escAlert: false, forwardCollisionWarning: false, handsOffWheelAlert: false, notificationsEnabled: false, rscAlert: false, severeBraking: false, weightDistribution: false, lkaAutoStopCompleted: false, activeSpeedInterventionEnabled: false, handsOffTheWheelAlert30sEnabled: false, handsOffTheWheelAlert60sEnabled: false, safetyEventActiveSideGuardAssistBrakingEnabled: false, safetyEventActiveSideGuardAssistSteeringEnabled: false, safetyEventRollawayInterventionEnabled: false, safetyEventManualEventEnabled: false }, config)); };
exports.customerLoadingFactory = customerLoadingFactory;
var userStateFactory = function (config) { return (__assign({ customerLoading: (0, exports.customerLoadingFactory)(), httpRequestError: false, isSigningIn: false, isAuthenticated: false, isLoaded: false, error: undefined, UserTANs: [], unitsSystemType: UNITS_SYSTEM_TYPES.IMPERIAL, vtRegisterError: false, vtRegisterSuccess: false }, config)); };
exports.userStateFactory = userStateFactory;
var termsOfUseStateFactory = function (config) { return (__assign({ termsOfUseError: false, termsOfUseAreLoading: false, termsOfUseUpdateError: false, termsOfUseUpdateIsLoading: false, termsOfUse: '', termsOfUseVersion: '', termsOfUseStatus: false }, config)); };
exports.termsOfUseStateFactory = termsOfUseStateFactory;
